/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeInterval } from './TimeInterval';
import {
    TimeIntervalFromJSON,
    TimeIntervalFromJSONTyped,
    TimeIntervalToJSON,
} from './TimeInterval';

/**
 * 
 * @export
 * @interface PatientClearance
 */
export interface PatientClearance {
    /**
     * 
     * @type {string}
     * @memberof PatientClearance
     */
    clearance_id: string;
    /**
     * 
     * @type {number}
     * @memberof PatientClearance
     */
    remaining_uses?: number;
    /**
     * 
     * @type {TimeInterval}
     * @memberof PatientClearance
     */
    expires_after?: TimeInterval;
    /**
     * 
     * @type {number}
     * @memberof PatientClearance
     */
    expires_on?: number;
    /**
     * 
     * @type {TimeInterval}
     * @memberof PatientClearance
     */
    minimum_interval?: TimeInterval;
}

/**
 * Check if a given object implements the PatientClearance interface.
 */
export function instanceOfPatientClearance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clearance_id" in value;

    return isInstance;
}

export function PatientClearanceFromJSON(json: any): PatientClearance {
    return PatientClearanceFromJSONTyped(json, false);
}

export function PatientClearanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientClearance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clearance_id': json['clearance_id'],
        'remaining_uses': !exists(json, 'remaining_uses') ? undefined : json['remaining_uses'],
        'expires_after': !exists(json, 'expires_after') ? undefined : TimeIntervalFromJSON(json['expires_after']),
        'expires_on': !exists(json, 'expires_on') ? undefined : json['expires_on'],
        'minimum_interval': !exists(json, 'minimum_interval') ? undefined : TimeIntervalFromJSON(json['minimum_interval']),
    };
}

export function PatientClearanceToJSON(value?: PatientClearance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clearance_id': value.clearance_id,
        'remaining_uses': value.remaining_uses,
        'expires_after': TimeIntervalToJSON(value.expires_after),
        'expires_on': value.expires_on,
        'minimum_interval': TimeIntervalToJSON(value.minimum_interval),
    };
}

